import { authState } from '@/state';
import logger, { logMixin } from '@/util/logger';
import { auth } from '@rock/db-admin';
import { onAuthStateChanged } from 'firebase/auth';
import { useSetAtom } from 'jotai/index';
import { type FC, type PropsWithChildren, useEffect } from 'react';

const log = logger('AuthInitializer');

/** The single `onAuthStateChanged` listener: keeps `authState` and the Datadog user mixin current. */
const AuthInitializer: FC<PropsWithChildren> = ({ children }) => {
    const setAuthState = useSetAtom(authState);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            log.info('Auth State Changed', { user });
            logMixin({
                usr: user
                    ? {
                          id: user.uid,
                          name: user.displayName,
                          email: user.email,
                      }
                    : null,
            });
            setAuthState({ user, loading: false });
        });

        return () => unsubscribe();
    }, [setAuthState]);

    return children;
};

export default AuthInitializer;
